(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kyren-collection-jump-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (nav) => {
      if (!nav || nav.dataset.ready) return;
      nav.dataset.ready = '1';
      const chips = [...nav.querySelectorAll('[data-target]')];
      const targets = chips.map((chip) => document.getElementById(chip.dataset.target)).filter(Boolean);
      if (!targets.length || !('IntersectionObserver' in window)) return;
      const setActive = (id) => {
        chips.forEach((chip) => {
          const active = chip.dataset.target === id;
          chip.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) {
            const list = chip.closest('.kjn__list');
            if (list && list.scrollWidth > list.clientWidth) {
              list.scrollTo({ left: chip.offsetLeft - list.clientWidth / 2 + chip.clientWidth / 2, behavior: 'smooth' });
            }
          }
        });
      };
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setActive(entry.target.id);
          });
        },
        { rootMargin: '-45% 0px -50% 0px' }
      );
      targets.forEach((t) => io.observe(t));
    };
    document.querySelectorAll('[data-kjn]').forEach(setup);
    document.addEventListener('shopify:section:load', (e) => setup(e.target.querySelector('[data-kjn]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyren-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    const arm = (root) => {
      root.querySelectorAll('[data-kcs]:not([data-armed])').forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
          el.classList.add('is-visible');
        }
        el.setAttribute('data-armed', '');
        io.observe(el);
      });
    };
    arm(document);
    document.addEventListener('shopify:section:load', (e) => arm(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
